import { SansTitle } from '@velasca/ui/sans-title'
import { SerifTitle } from '@velasca/ui/serif-title'
import type { SizeGuideHeaderProps } from './SizeGuideHeader.types'

export const SizeGuideHeader = ({
  upperTitle,
  title,
}: SizeGuideHeaderProps): JSX.Element | null => {
  if (!upperTitle && !title) {
    return null
  }

  return (
    <>
      {upperTitle && (
        <SansTitle center tracking="wide" as="h3" size="sm" color="primary">
          {upperTitle}
        </SansTitle>
      )}
      {title && (
        <SerifTitle center as="h2" size="md" color="primary" margin="0 0 3rem">
          {title}
        </SerifTitle>
      )}
    </>
  )
}
